import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/frontend-plugin-api';
import { createApiFactory } from '@backstage/core-plugin-api';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';

// Replaces the default WebStorage (localStorage-only) with UserSettingsStorage,
// which persists to the user-settings backend and syncs across devices.
// Requires plugin-user-settings-backend to be registered in packages/backend/src/index.ts.
const storageApi = ApiBlueprint.make({
  name: 'storage',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: storageApiRef,
        deps: {
          fetchApi: fetchApiRef,
          discoveryApi: discoveryApiRef,
          errorApi: errorApiRef,
          identityApi: identityApiRef,
        },
        factory: ({ fetchApi, discoveryApi, errorApi, identityApi }) =>
          UserSettingsStorage.create({
            fetchApi,
            discoveryApi,
            errorApi,
            identityApi,
          }),
      }),
    ),
});

export const storageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [storageApi],
});
